import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
export function FinalCtaSection() {
  const features = ['Acceso Inmediato', 'Garantía 30 Días', 'Sin Pastillas', 'Para Mayores de 50'];
  return <section id="checkout" className="py-20 md:py-28 bg-[#0d1530] scroll-mt-8" data-id="element-154">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-155">
        <FadeIn data-id="element-156">
          <h2 className="text-3xl md:text-5xl font-serif mb-6 text-glow leading-tight" data-id="element-157">
            Tus mejores noches comienzan esta misma noche.
          </h2>
          <p className="text-body-xl text-cream-muted mb-12 max-w-2xl mx-auto" data-id="element-158">
            Da el primer paso para recuperar tu energía, tu claridad mental y tu
            vitalidad.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-159">
          <a href="https://info-marketingdigital.com/cart/53014866657596:1" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center justify-center gap-3 px-10 md:px-14 py-5 md:py-6 text-lg md:text-xl font-medium rounded-md bg-gold-500 text-[#0A0E2A] hover:bg-gold-400 hover:-translate-y-1 hover:shadow-[0_0_40px_rgba(201,168,76,0.5)] transition-all duration-300 box-glow" style={{
          animation: 'pulse 3s ease-in-out infinite'
        }} data-id="element-160">
            Quiero Dormir Mejor Esta Noche
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-161" />
          </a>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-162">
          <div className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-163">
            {features.map((f, i) => <div key={i} className="flex items-center gap-2 text-cream-muted" data-id="element-164">
                <CheckIcon className="w-4 h-4 text-gold-400 flex-shrink-0" data-id="element-165" />
                <span className="text-sm md:text-base" data-id="element-166">{f}</span>
              </div>)}
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-167">
          <div className="mt-12 pt-8 border-t border-white/15" data-id="element-168">
            <p className="text-xs uppercase tracking-widest text-cream-muted mb-5" data-id="element-169">
              Pago Seguro
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-170">
              {['VISA', 'Mastercard', 'PayPal', 'Stripe'].map((m, i) => <div key={i} className="card-glass rounded px-4 py-2 text-sm font-medium text-white tracking-wide min-w-[90px] text-center" data-id="element-171">
                  {m}
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}